export default "__VITE_ASSET__BnZqPERw__"